var map = {
	"./emoji-agenda.svg": 686,
	"./emoji-box.svg": 687,
	"./emoji-camera.svg": 688,
	"./emoji-capsule.svg": 689,
	"./emoji-chat.svg": 690,
	"./emoji-done.svg": 691,
	"./emoji-facebook.svg": 692,
	"./emoji-france.svg": 693,
	"./emoji-grec.svg": 694,
	"./emoji-instagram.svg": 695,
	"./emoji-lampe.svg": 696,
	"./emoji-laptop.svg": 697,
	"./emoji-linkedin.svg": 698,
	"./emoji-maroc.svg": 699,
	"./emoji-messagerie.svg": 700,
	"./emoji-money.svg": 701,
	"./emoji-money2.svg": 702,
	"./emoji-pen.svg": 703,
	"./emoji-point.svg": 704,
	"./emoji-smile.svg": 705,
	"./emoji-smileSick.svg": 706,
	"./emoji-stats.svg": 707,
	"./emoji-tick.svg": 708,
	"./emoji-write.svg": 709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 685;